import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@eversports/klimt-design-components/tailwind/utils'

const variants = cva('flex w-fit select-none rounded-md px-1 py-0.5 text-sm font-medium', {
  variants: {
    variant: {
      primary: 'text-text-brand-primary',
      secondary: 'text-text-brand-secondary',
      tertiary: 'text-text-brand-tertiary',
      warning: 'text-text-error',
      custom: 'text-text-secondary',
    },
    style: {
      outline: 'border',
      solid: '',
    },
    disabled: {
      true: 'text-text-disabled pointer-events-none',
      false: '',
    },
  },
  compoundVariants: [
    {
      variant: 'primary',
      style: 'outline',
      disabled: false,
      className: 'border-text-brand-primary bg-white',
    },
    {
      variant: 'primary',
      style: 'solid',
      disabled: false,
      className: 'bg-surface-brand-primary-light',
    },
    {
      variant: 'secondary',
      style: 'outline',
      disabled: false,
      className: 'border-border-brand-secondary bg-white',
    },
    {
      variant: 'secondary',
      style: 'solid',
      disabled: false,
      className: 'bg-surface-brand-secondary-subtle',
    },
    {
      variant: 'tertiary',
      style: 'outline',
      disabled: false,
      className: 'border-border-brand-tertiary bg-white',
    },
    {
      variant: 'tertiary',
      style: 'solid',
      disabled: false,
      className: 'bg-surface-brand-tertiary-subtle',
    },
    {
      variant: 'warning',
      style: 'outline',
      disabled: false,
      className: 'border-text-error bg-white',
    },
    {
      variant: 'warning',
      style: 'solid',
      disabled: false,
      className: 'bg-surface-error-disabled',
    },
    {
      variant: 'custom',
      style: 'outline',
      disabled: false,
      className: 'border-border-enabled bg-white',
    },
    {
      variant: 'custom',
      style: 'solid',
      disabled: false,
      className: 'bg-surface-neutral',
    },
    {
      style: 'outline',
      disabled: true,
      className: 'border-border-disabled',
    },
    {
      style: 'solid',
      disabled: true,
      className: 'bg-surface-disabled',
    },
  ],
  defaultVariants: {
    variant: 'primary',
    style: 'outline',
    disabled: false,
  },
})

interface Props extends VariantProps<typeof variants> {
  text: string
}

export function Tag({ variant, style, text, disabled }: Props) {
  return (
    <div className={cn(variants({ variant, style, disabled }))} aria-disabled={disabled ? 'true' : undefined}>
      {text}
    </div>
  )
}
